import React from 'react';
import { motion } from 'framer-motion';
import { asset } from '@/lib/api';
import { EASE } from '@/lib/motion';

// Reusable cinematic dark hero for inner pages.
export const PageHero = ({ eyebrow, title, subtitle, image, meta, minH = 'min-h-[62vh]' }) => {
  return (
    <section className={`relative flex items-end overflow-hidden bg-[#20272A] ${minH} pt-28 pb-14`}>
      {image && (
        <motion.div
          className='absolute inset-0'
          initial={{ scale: 1.12 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.4, ease: EASE }}
        >
          <img src={asset(image)} alt='' className='h-full w-full object-cover' />
        </motion.div>
      )}
      <div
        className='absolute inset-0'
        style={{
          background:
            'linear-gradient(180deg, rgba(7,91,97,0.55) 0%, rgba(32,39,42,0.72) 55%, rgba(32,39,42,0.94) 100%)',
        }}
      />
      <div className='grain absolute inset-0' />
      <div className='relative container-x'>
        {eyebrow && (
          <motion.div
            className='flex items-center gap-3'
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: EASE }}
          >
            <span className='h-px w-10 bg-[#B88A3B]' />
            <span className='eyebrow text-[#B88A3B]'>{eyebrow}</span>
          </motion.div>
        )}
        <motion.h1
          className='mt-5 max-w-4xl font-head text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.03] tracking-[-0.02em] text-[#F6F5F1]'
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: EASE, delay: 0.08 }}
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            className='mt-6 max-w-2xl text-base sm:text-lg leading-relaxed text-[#F6F5F1]/75'
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: EASE, delay: 0.16 }}
          >
            {subtitle}
          </motion.p>
        )}
        {meta && <div className='mt-8'>{meta}</div>}
      </div>
    </section>
  );
};
